import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CeIconComponent } from '@enginuity/core/atoms/ce-icon/ce-icon.component';

@Component({
  selector: 'app-tags',
  standalone: true,
  imports: [CommonModule, CeIconComponent],
  templateUrl: './tags.component.html',
  styleUrls: ['./tags.component.scss'],
})
export class TagsComponent {
  @Output() dismiss: EventEmitter<string> = new EventEmitter<string>();
  @Output() remove: EventEmitter<string> = new EventEmitter<string>();

  @Input() ellipsis = true;
  @Input() parentLabel = false;
  @Input() codeView = false;
  @Input() parentText: string | unknown = 'Label';
  @Input() label: string | unknown = 'tag';
  @Input() value = '';
  @Input() close = true;

  dismissOption($event: Event) {
    $event.stopPropagation();
    this.dismiss.emit(this.label?.toString());
    this.remove.emit(this.value);
  }
}
